export const TEMPLATE_EXPIRY_EXCEEDS_SENDER_EXPIRY_MESSAGE =
    'The template expiration date cannot exceed the sender name’s expiration date.';

export const TEMPLATE_RENEWAL_NO_TEMPLATES_MESSAGE = 'No templates found for renewal.';

const backendMessageKeys: Array<{ message: string, key: string }> = [
    { message: TEMPLATE_EXPIRY_EXCEEDS_SENDER_EXPIRY_MESSAGE, key: 'shared.templateExpiryExceedsSenderExpiry' },
    { message: 'Selected templates must belong to the same sender name.', key: 'dashboardPage.templateRenewalDifferentSenders' },
    { message: 'The template is not eligible for renewal.', key: 'dashboardPage.templateNotEligibleForRenewal' },
    {
        message: 'A pending payment renewal request already exists for this template.',
        key: 'dashboardPage.templateRenewalPendingExists',
    },
    {
        message: 'Template renewal is not available because template renewal is disabled.',
        key: 'dashboardPage.templateRenewalPaymentDisabled',
    },
    {
        message: 'Sender renewal payment is required before Template renewal payment.',
        key: 'dashboardPage.templateRenewalSenderNotRenewed',
    },
    { message: 'The provider does not have an active contract.', key: 'dashboardPage.templateRenewalNoActiveContract' },
    {
        message: 'No pending sender name renewal was found for these templates.',
        key: 'dashboardPage.templateRenewalNoPendingSenderExtension',
    },
    {
        message: 'The sender name has expired. Please renew the sender name first.',
        key: 'dashboardPage.templateRenewalSenderExpired',
    },
    {
        message: 'The sender name must be Paid before paying for Template renewal.',
        key: 'dashboardPage.templateRenewalSenderNotPaid',
    },
    {
        message: 'The sender name renewal duration must be between 1 and 5 years.',
        key: 'dashboardPage.templateRenewalInvalidExtendDuration',
    },
];

export function translateTemplateRenewalMessage(message: string, translate: (key: string) => string): string | null {
    if (!message) {
        return null;
    }
    const match = backendMessageKeys.find((m) => message.indexOf(m.message) !== -1);
    if (match === undefined) {
        return null;
    }
    return message.replace(match.message, translate(match.key));
}
